// extracted by mini-css-extract-plugin
export default {"requiredFieldsLabel":"RequiredFieldLabel_requiredFieldsLabel__AWDpO"};